export const findYourBraSizeQuery = `
  query getYourBraSize($answers: [Answer]){
    findYourBraSize(answers: $answers) {
      cdpURL
      sizeSupported
      sizes {
        bandSize
        numberedSize
        numberedSizeLabel
        letteredSize
        letterSizeLabel
        coverages
      }
    }
  }
`;
